// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-plasmic-components-pages-index-jsx": () => import("./../../.plasmic/components/pages/index.jsx" /* webpackChunkName: "component---cache-plasmic-components-pages-index-jsx" */)
}

